import React from "react";
import { DocumentIcon } from "./Icons";

interface DocumentNameCellProps {
  name: string;
  /** When provided the name becomes a clickable link that opens the history drawer */
  onClick?: (e?: React.MouseEvent) => void;
}

/**
 * Renders the "Document" column cell: a blue icon + the document name.
 *
 * When `onClick` is supplied the name renders as a button with a hover
 * underline so users know it's interactive.  The click opens the
 * HistoryDrawer for that row.
 */
const DocumentNameCell: React.FC<DocumentNameCellProps> = ({
  name,
  onClick,
}) => (
  <div
    className={`flex items-center ${onClick ? "cursor-pointer group" : ""}`}
    onClick={onClick}
    role={onClick ? "button" : undefined}
    tabIndex={onClick ? 0 : undefined}
    onKeyDown={
      onClick
        ? (e) => {
            if (e.key === "Enter" || e.key === " ") onClick();
          }
        : undefined
    }
    style={onClick ? { cursor: "pointer" } : undefined}
  >
    <div className="flex-shrink-0 h-8 w-8 bg-[#EFF6FF] rounded flex items-center justify-center mr-3">
      <DocumentIcon className="h-4 w-4 text-[#2563EB]" />
    </div>
    <span
      className={`font-medium text-[#111827] ${
        onClick
          ? "group-hover:text-[#2563EB] group-hover:underline transition-colors"
          : ""
      }`}
    >
      {name}
    </span>
  </div>
);

export default DocumentNameCell;
